<template>
  <c-loading-area :loading="false" class="nav-tab-small">
    <v-card-title>
      {{ $t('page.currentUser.section.login.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.currentUser.section.login.description') }}
    </v-card-subtitle>
    <v-card-text class="my-3">
      <dl class="d-grid">
        <dt>{{ $t('page.currentUser.section.login.username') }}</dt>
        <dd>{{ user.username }}</dd>
        <dt>{{ $t('page.currentUser.section.login.firstName') }}</dt>
        <dd>{{ user.firstName }}</dd>
        <dt>{{ $t('page.currentUser.section.login.lastName') }}</dt>
        <dd>{{ user.lastName }}</dd>
        <dt>{{ $t('page.currentUser.section.login.email') }}</dt>
        <dd>{{ user.emailAddress }}</dd>
        <dt>{{ $t('page.currentUser.section.login.password') }}</dt>
        <dd style="font-family:monospace">
          &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
        </dd>
      </dl>
    </v-card-text>
    <v-card-actions class="justify-end">
      <c-btn type="primary" class="px-4" @click="redirectToIDP">
        {{ $t('page.currentUser.button.editLogin') }}
        <v-icon right>
          mdi-open-in-new
        </v-icon>
      </c-btn>
    </v-card-actions>
  </c-loading-area>
</template>

<script>
import axios from 'axios';
import { useUserStore } from '@/stores/userStore';
import { useApplicationStore } from '@/stores/applicationStore';

const userStore = useUserStore();
const applicationStore = useApplicationStore();

export default {
  computed: {
    user () {
      return userStore;
    }
  },
  methods: {
    redirectToIDP () {
      this.$cove.confirm({ message: this.$t('page.currentUser.section.login.editConfirmation') })
        .then((confirmed) => {
          if (confirmed)
          {
            axios.delete(this.$cove.getAPI({ name: 'api.user.terminateSession' }))
              .then(() => {
                window.location.href = applicationStore.getAppProperty(this.CONST.APP_PROPERTY_ACCOUNT_URL);
              });
          }
        });
    }
  }
};
</script>